import { useEffect } from 'react';
import { Table } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { showroomListAction, showroomAuditoriaAction } from '../../actions/ShowroomActions';
import styled from 'styled-components';

const StyledTable = styled(Table)`
  &&& {
    border: none;
    width: 100%;
    text-align: center;
  }
`; 

const StyledTableHeader = styled(Table.Header)`
  &&& th {
    border: none !important;
    font-weight: bold;
    padding: 0px 0;
    text-align: center;
  }

  @media print {
    * {
  font-weight: bold !important;
  font-size: 12px !important;
  background-color: gray !important;
  }
`;

const StyledTableBody = styled(Table.Body)`
  &&& td {
    border: none !important;
    padding: 0px 0 !important;
    text-align: center;
  }

  tr:nth-child(even) {
    background-color: #add8e6 !important;;
    print-color-adjust: exact; 
    -webkit-print-color-adjust: exact;
  }
`;



const PrintContainer = styled.div`

.print-only {
  display: none;
}


@media print {
  * {
  border-collapse: collapse !important;
}


.print-only {
  margin-top: 15px !important;
}

body {
  font-size: 9px !important;
  line-height: 0.5 !important
  color-adjust: exact !important;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}



  /* table {
    width: 100% !important;
    font-size: 9px !important;
  }

  th, td {
    padding: 0px 0px !important;
  }

  tr {
    height: auto !important; */
  }

  .print-only {
    display: block !important;
    margin-top: 5px !important;
    padding-top: 5px !important; /* Adiciona um espaço extra se a margem for zerada */
  }

  .show-on-screen {
    display: none !important;
  }

  tr:nth-child(even) {
    background-color: #add8e6 !important;
    color-adjust: exact !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .print-container {
    height: 100vh;
    max-height: 29.7cm;
    overflow: hidden;
  }

  .StyledTable {
    table-layout: fixed;
  }

  .hide-on-print {
    display: none !important;
  }

  table {
    page-break-inside: avoid !important;
  }

  tr {
    page-break-before: auto;
    page-break-after: auto;
  }
}
`;

const ShowroomFolhaA5 = ({ showroomListAction, showroomlist, selectedLocal, cdatual, showroomAuditoriaAction }) => {
  useEffect(() => {
    showroomListAction(cdatual);
    showroomAuditoriaAction()
  }, []);


  const filteredList = showroomlist.filter(item => item.local === selectedLocal);
  const versaoFinal = filteredList.length > 0 ? filteredList[0].versao : "N/A";

  // Verifica se há pelo menos um item com cada atributo
  const hasDescAtributo1 = filteredList.some(item => item.desc_atributo1);
  const hasAtributo1 = filteredList.some(item => item.atributo1);
  const hasDescAtributo2 = filteredList.some(item => item.desc_atributo2);
  const hasAtributo2 = filteredList.some(item => item.atributo2);
  const hasDescAtributo3 = filteredList.some(item => item.desc_atributo3);
  const hasAtributo3 = filteredList.some(item => item.atributo3);

  const itemCount = filteredList.length;
  // Define dinamicamente o tamanho da fonte e o padding
  const dynamicFontSize = itemCount > 15 ? "9px" : `${Math.min(15, 9 + (15 - itemCount) * 0.8)}px`;
  const dynamicPadding = itemCount > 15 ? "2px 10px" : `${Math.min(6, 2 + (15 - itemCount) * 2)}px 10px`;


  return (
    <>
      {selectedLocal && (
        <div>

          <PrintContainer>
            {/* Versão para TELA */}
            <div className="show-on-screen">
              <table style={{ borderCollapse: 'collapse', width: '750px' }}>
                <thead>
                  <tr>
                    <th style={{ width: '30px', border: '1px solid #ccc', padding: '0px' }}>SKU</th>
                    <th style={{ width: '265px', border: '1px solid #ccc', padding: '0px' }}>Nome</th>
                    <th style={{ width: '60px', border: '1px solid #ccc', padding: '0px' }}></th>
                    <th style={{ width: '30px', border: '1px solid #ccc', padding: '0px' }}>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.map((item, idx) => (
                    <tr>
                      <td style={{ border: '1px solid #ccc', padding: '0px', fontSize: '18px' }}>{item.codprod}</td>
                      <td style={{ border: '1px solid #ccc', padding: '0px', fontSize: '18px' }} >{item.descprod} {item.atributo1 ? `(${item.atributo1})` : ''}</td>
                      <td style={{ border: '1px solid #ccc', padding: '0px', fontSize: '18px' }}>{item.volume}</td>
                      <td style={{ border: '1px solid #ccc', padding: '0px', fontSize: '18px' }}>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(item.preco_versao)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>

            {/* Versão para IMPRESSÃO */}
            <div className="print-only">
              <div style={{ display: 'flex', width: '700px', flexDirection: 'row', justifyContent: 'flex-end' }}>
                <b style={{ fontSize: '14px' }}>
                  Valores sem impostos*
                </b>
              </div>
              <table style={{ borderCollapse: 'collapse', width: '700px' }}>
                <thead style={{ backgroundColor: '#808080' }}>
                  <tr>
                    <th style={{ width: '30px', padding: '0px' }}>SKU</th>
                    <th style={{ width: '265px', padding: '0px' }}>Nome</th>
                    <th style={{ width: '30px', padding: '0px' }}></th>
                    <th style={{ width: '30px', padding: '0px' }}>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.map((item, idx) => (
                    <tr>
                      <td style={{ padding: '0px', textAlign: 'center', fontSize: '18px', padding: '0px' }}>{item.codprod}</td>
                      <td style={{ padding: '0px', textAlign: 'center', fontSize: '16px', padding: '0px' }} >
                        {item.descprod} {item.atributo1 ? `(${item.atributo1})` : ''}

                        {item.frase && item.rendimento && (
                          <div style={{ fontSize: '0.8em', color: '#666', lineHeight: '1.1', marginTop: '0' }}>
                            {item.frase + item.rendimento}
                          </div>
                        )}

                      </td>
                      {hasDescAtributo2 && (
                        <td style={{ padding: '0px', textAlign: 'center', fontSize: '18px', padding: '0px' }}>{item.atributo2 || ''}</td>
                      )}
                      <td style={{ padding: '0px', textAlign: 'center', fontSize: '14px', padding: '0px' }}>
                        <div style={{ fontSize: '1.2em', fontWeight: 'bold', lineHeight: '1.1' }}>
                          {new Intl.NumberFormat("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          }).format(item.precocomercial)} / {item.unidadecomercial}
                        </div>
                        {item.frase && item.rendimento ? <div style={{ fontSize: '0.9em', color: '#666', lineHeight: '1.1' }}>
                          {new Intl.NumberFormat("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          }).format(item.precovenda)} / {item.unidadevenda}
                        </div>
                          : ''}


                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{ marginTop: '5px', width: '700px', textAlign: 'center', fontWeight: 'bold', fontSize: '18px' }}>
                Expositor: {selectedLocal} v.{versaoFinal}

              </div>
            </div>
          </PrintContainer>
        </div>
      )}
    </>
  );
};

export default withRouter(connect(state => ({
  showroomlist: state.ShowroomReducer.showroomlist,
  cdatual: state.ShowroomReducer.cdatual
}), { showroomListAction, showroomAuditoriaAction })(ShowroomFolhaA5));
